import React from 'react'
import ContactUs from '../components/Contact'
import Home from '../components/Home'
import Skills from '../components/Skills'
import { Toaster } from 'react-hot-toast'

// Scroll
import { ScrollToTop } from '../components/ScrollToTop'

const HomePage = () => {
    return (
        <>
            <Home />
            <Skills />
            <Toaster />
            <ContactUs />
            <ScrollToTop />
        </>
    )
}

export default HomePage
